import styled from 'styled-components'

export const FactsBox = styled.div`
  .facts-container {
    display: flex;
    flex-direction: column;
    padding: 11px 20px 20px 39px;
    max-width: 786px;
    font-stretch: normal;
    font-style: normal;

    a {
      text-decoration: none;
    }

    .component-title {
      color: ${ (props) => props.theme.colors['panel-inner-border'] };
      margin-bottom: 7px;
    }

    .title {
      font-size: 24px;
      font-weight: 300;
      line-height: 1.21;
      letter-spacing: normal;
      color: ${ (props) => props.theme.colors['standard-schwarz'] };
      margin-bottom: 15px;
    }

    .content {
      display: flex;
      flex-direction: row;
      align-items: flex-end;

      // overwrite margin
      .text {
        margin: 0 40px 0 0;
        @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
          margin: 0;
        }
      }

      .arrow-link {
        @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
          display: none;
        }
      }
    }

    .text {
      font-size: 18px;
      font-weight: 300;
      line-height: 1.39;
      letter-spacing: normal;
      color: ${ (props) => props.theme.colors['standard-schwarz'] };
    }
  }
`
